import { _ as _defineProperty } from '../defineProperty-2d1aa32d.js';
import { authorizationHeader } from '@picsart/growth-rc/services/auth';
import { get, getApiUrl } from '../httpService/index.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CREDIT_TOOL_ID = 'credit';
var CREDIT_TOOLS = [CREDIT_TOOL_ID]; // later ai_avatar maybe added too

var fetchCredits = function fetchCredits(accessToken, doNotEnroll) {
  return get("".concat(getApiUrl(), "/guard/credits").concat(doNotEnroll ? '' : '?is_credit_user=true'), {
    headers: _objectSpread({
      platform: 'website'
    }, authorizationHeader(accessToken))
  })["catch"](function () {
    return {
      status: 'success',
      response: null
    };
  });
};
var isCreditToolId = function isCreditToolId(toolId) {
  return !!toolId && CREDIT_TOOLS.includes(toolId);
};
var creditsService = {
  isCreditToolId: isCreditToolId,
  fetchCredits: fetchCredits,
  CREDIT_TOOL_ID: CREDIT_TOOL_ID,
  CREDIT_TOOLS: CREDIT_TOOLS
};

export { CREDIT_TOOLS, CREDIT_TOOL_ID, creditsService as default, fetchCredits, isCreditToolId };
//# sourceMappingURL=index.js.map
